import React, { useEffect, useRef, useState } from 'react';

import { useIsPrimaryDark, useMuted } from 'widget/hooks';
import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

import { Modal } from './components';
import Chat from './chat/chat';
import Container from './container/container';
import ContentContext from './content-context';
import Trigger from './trigger/trigger';

const Content = () => {
  const { isWidgetActive, widget } = useWidgetContext();

  const [isCallbackActive, setIsCallbackActive] = useState(false);
  const [isChatActive, setIsChatActive] = useState(false);
  const [maxSize, setMaxSize] = useState<Env.MaxSize>();
  const [position, setPosition] = useState<Env.Position>();

  const isPrimaryDark = useIsPrimaryDark();
  const muted = useMuted();
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!position) return;

    setMaxSize({
      maxHeight: window.innerHeight - position.bottom * 2,
      maxWidth: window.innerWidth - position.right * 2,
    });
  }, [position]);

  const getIsShift = () => {
    if (!isWidgetActive) return false;
    else if (widget.type != 'radial') return false;
    else if (!wrapperRef.current?.children.length) return false;
    else if (wrapperRef.current?.children.length < 5) return false;

    return true;
  };

  const handleResize = () => {
    const isMobile = window.innerWidth <= 425;

    const isShift = getIsShift();
    if (isShift) return setPosition({ bottom: 80, right: 80 });

    const bottom = isMobile ? widget.bottom_mobile : widget.bottom;
    const right = isMobile ? widget.right_mobile : widget.right;

    setPosition({
      bottom: typeof bottom == 'number' ? bottom : 40,
      right: typeof right == 'number' ? right : 40,
    });
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const { colors } = widget;

  const contrast =
    widget.theme == 'dark'
      ? '#ffffff'
      : isPrimaryDark
        ? colors.primary
        : '#1f1f1f';

  const style = {
    ...position,
    '--contrast': contrast,
    '--muted': muted,
    '--primary': colors.primary,
    '--secondary': colors.secondary,
  } as React.CSSProperties;

  return (
    <ContentContext.Provider value={{ setIsCallbackActive, setIsChatActive }}>
      {position && (
        <div className="whatcrm-widget-content" style={style}>
          {maxSize && (
            <>
              {widget.is_chat && (
                <Chat isActive={isChatActive} maxSize={maxSize} />
              )}

              <Container maxSize={maxSize} ref={wrapperRef} />
            </>
          )}

          <Trigger
            isCallbackActive={isCallbackActive}
            isChatActive={isChatActive}
          />

          {widget.is_callback && widget.type != 'horizontal' && (
            <Modal
              isActive={isCallbackActive}
              setIsActive={setIsCallbackActive}
            />
          )}
        </div>
      )}
    </ContentContext.Provider>
  );
};

export default Content;
